export const ACTION_METHODS = {

    PAGE_VISIT : 'PAGE_VISIT',
    BUTTON_CLICK : 'BUTTON_CLICK',
    TAB_VISIT_ON_PAGE: 'TAB_VISIT_ON_PAGE',
    PAGE_LOAD_TIME: 'PAGE_LOAD_TIME',
    TIME_SPENT_ON_PAGE: 'TIME_SPENT_ON_PAGE',
    SESSION_DURATION: 'SESSION_DURATION',
    FAILURE: 'FAILURE',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    INFO: 'INFO',
    WARNING: 'WARNING',
    DEBUG: 'DEBUG',
    CLICK: 'CLICK',
    HOVER: 'HOVER',
    PAGE_LOAD: 'PAGE_LOAD',
    PAGE_UNLOAD: 'PAGE_UNLOAD',
    PAGE_READY: 'PAGE_READY',
    PAGE_ERROR: 'PAGE_ERROR',
    PAGE_INFO: 'PAGE_INFO',
    PAGE_WARNING: 'PAGE_WARNING',
    PAGE_DEBUG: 'PAGE_DEBUG',
    PAGE_CLICK: 'PAGE_CLICK',
    PAGE_HOVER: 'PAGE_HOVER',
    PAGE_FAILURE: 'PAGE_FAILURE',
    PAGE_SUCCESS: 'PAGE_SUCCESS',
    SIGN_IN_TIME: 'SIGN_IN_TIME'
}

export const SITE_SERVICES = {

    ACCOUNTING_BI_CENTRAL : 'ACCOUNTING_BI_CENTRAL',
    CLOSE_PORTAL : 'CLOSE_PORTAL',
    FRISCO : 'FRISCO',
    LOGICO: 'LOGICO',
    FLEXICO: 'FLEXICO',
    CRUZER: 'CRUZER',
    TANC: 'TANC',
    ACCOUNTING_CENTRAL_APP: 'ACCOUNTING_CENTRAL_APP',
    QSC_APP: 'QSC_APP',
    ADMIN_PANEL: 'ADMIN_PANEL',
    BOFFIN: 'BOFFIN',
    TED: 'TED',
    CORPORATE_REPORTING_CENTRAL: 'CORPORATE_REPORTING_CENTRAL',
    APPROVAL_SERVICE: 'APPROVAL_SERVICE',
    AUDIT_LOGS: 'AUDIT_LOGS',
    APPS_LIBRARY: 'APPS_LIBRARY',
    FIRST_PASS_PRO: 'FIRST_PASS_PRO',

}

export const METRIC_TYPE = {
  COUNTER : "COUNTER",
  STRING : "STRING",
  TIMER : "TIMER"
}

export interface METRIC_CONFIG {
  metricType: string;
  metricName: string;
  metricValue: string | number;
  isMonitor: boolean;
}
